export default "__VITE_ASSET__Db_TsezA__"